const labels = {
  da: {
    header: 'Fakta om uddannelsen',
    quota1: 'Kvote 1',
    quota2: 'Kvote 2',
    standby: 'Standby',
    language: 'Undervisningssprog',
    location: 'Studiested',
    start: 'Studiestart',
  },
  en: {
    header: 'About the programme',
    quota1: 'Quota 1',
    quota2: 'Quota 2',
    standby: 'Standby',
    language: 'Language',
    location: 'Place of study',
    start: 'Commencement',
  },
};

export default labels;
